import { API_BASE_URL as API_URL } from '../config';

/**
 * Helper function to handle 401 (Unauthorized) responses by redirecting to login
 */
const handleUnauthorized = () => {
  sessionStorage.clear();
  const loginUrl = process.env.REACT_APP_LOGIN_URL || (window.location.hostname.includes('-staging') ? window.location.origin : window.location.origin.replace('app.signalcue.ai', 'signalcue.ai'));
  window.location.href = `${loginUrl}/login`;
};

const checkUnauthorized = (response) => {
  if (response.status === 401) {
    handleUnauthorized();
    throw new Error('Token has expired. Redirecting to login...');
  }
};

const getAuthHeaders = () => {
  const token = sessionStorage.getItem('signalcue_token');
  if (!token) {
    throw new Error('Not authenticated');
  }
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

export const targetCompanyService = {
  /**
   * Get list of target companies
   */
  async getTargetCompanies(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.offset) queryParams.append('offset', params.offset);
    if (params.search) queryParams.append('search', params.search);
    if (params.is_paused !== undefined) queryParams.append('is_paused', params.is_paused);
    if (params.target_confidence) queryParams.append('target_confidence', params.target_confidence);
    
    const response = await fetch(`${API_URL}/api/target-companies?${queryParams.toString()}`, {
      headers: getAuthHeaders()
    });

    checkUnauthorized(response);

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to get target companies');
    }

    return response.json();
  },

  /**
   * Add a new target company
   */
  async addTargetCompany(companyData) {
    const response = await fetch(`${API_URL}/api/target-companies`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(companyData)
    });

    checkUnauthorized(response);

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to add target company');
    }

    return response.json();
  },

  /**
   * Update a target company
   */
  async updateTargetCompany(companyId, updates) {
    const response = await fetch(`${API_URL}/api/target-companies/${companyId}`, {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify(updates)
    });

    checkUnauthorized(response);

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to update target company');
    }

    return response.json();
  },

  /**
   * Remove a company from target list
   */
  async removeTargetCompany(companyId) {
    const response = await fetch(`${API_URL}/api/target-companies/${companyId}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });

    checkUnauthorized(response);

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to remove target company');
    }

    return response.json();
  }
};
